module.exports = __webpack_public_path__ + "img/alternator.259a2cd9.png";